import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

export default function AdminCommerceLayout() {
  const { pathname } = useLocation();

  return (
    <div className="admin-page">
      <div className="admin-page__body" key={pathname}>
        <Outlet />
      </div>
    </div>
  );
}
